<!-- Main Menu -->
<div class="inner-nav desktop-nav all-menu-responsive">
	<ul class="clearlist">
		<app-menu-item *ngFor="let item of menuItems" [item]="item" />
	</ul>
</div>